const productTypeLabels: { [key: string]: string } = {
  consumer: 'Consumo',
  mortgage: 'Hipotecario',
  microLoan: 'Microcrédito',
  downPayment: 'Pie hipotecario',
};

export default function getProductTypeLabels(
  productType: string,
  productSubtype?: string,
) {
  if (Object.keys(productTypeLabels).includes(productType)) {
    if (
      productType === 'mortgage'
        && productSubtype === 'transferable-subsidized-ds19'
    ) {
      return 'Mutuo Hipotecario DS-19';
    }
    return productTypeLabels[productType];
  }
  return productType;
}
